module.exports = __webpack_public_path__ + "img/MZ.64850e0b.svg";